import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';

export default function LoginPage() {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch(console.error);
    };

    return (
        <div style={styles.root}>
            <div style={styles.card}>
                <div style={styles.logo}>19th<span style={{ color: '#c9a84c' }}>View</span></div>
                <div style={styles.subtitle}>Admin Portal</div>
                <p style={styles.desc}>Sign in with your Microsoft account to continue.</p>
                <button style={styles.btn} onClick={handleLogin}>
                    Sign in with Microsoft
                </button>
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    root: {
        width: '100vw', height: '100vh',
        background: '#0a1a10',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    card: {
        background: '#fff',
        borderRadius: 16,
        padding: '48px 40px',
        width: 360,
        textAlign: 'center',
        boxShadow: '0 24px 64px rgba(0,0,0,0.2)',
    },
    logo: {
        fontSize: 32, fontWeight: 800,
        color: '#1a6b3c', letterSpacing: -1,
        marginBottom: 4,
    },
    subtitle: {
        fontSize: 14, color: '#666',
        marginBottom: 24,
        textTransform: 'uppercase',
        letterSpacing: 1,
    },
    desc: {
        fontSize: 14, color: '#444',
        marginBottom: 28, lineHeight: 1.6,
    },
    btn: {
        width: '100%', padding: '14px',
        background: '#1a6b3c', color: '#fff',
        border: 'none', borderRadius: 8,
        fontSize: 15, fontWeight: 600,
        cursor: 'pointer',
    },
};